<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      fill="white"
      r="11.5"
      stroke="#FF9537"
    />
    <path
      d="M12.0001 4.11523C9.5477 4.11523 7.54297 6.11996 7.54297 8.57238C7.54297 11.0248 9.5477 13.0295 12.0001 13.0295C14.4525 13.0295 16.4573 11.0248 16.4573 8.57238C16.4573 6.11996 14.4525 4.11523 12.0001 4.11523Z"
      fill="#FF9537"
    />
    <path
      d="M20.5348 16.6731C20.4045 16.3451 20.2308 16.0389 20.0354 15.7546C19.0366 14.2675 17.4949 13.2834 15.7578 13.0428C15.5407 13.0209 15.3019 13.0646 15.1281 13.1959C14.2162 13.8738 13.1305 14.2237 12.0014 14.2237C10.8722 14.2237 9.78656 13.8738 8.87458 13.1959C8.70086 13.0646 8.462 12.9991 8.24489 13.0428C6.50779 13.2834 4.94442 14.2675 3.96732 15.7546C3.7719 16.0389 3.59817 16.3669 3.46792 16.6731C3.40279 16.8043 3.42449 16.9574 3.48961 17.0886C3.66334 17.3948 3.88045 17.701 4.07588 17.9634C4.37985 18.3789 4.70557 18.7507 5.07472 19.1006C5.3787 19.4068 5.72611 19.6911 6.07356 19.9754C7.78892 21.2657 9.85173 21.9436 11.9797 21.9436C14.1076 21.9436 16.1704 21.2656 17.8858 19.9754C18.2332 19.713 18.5806 19.4068 18.8846 19.1006C19.232 18.7507 19.5794 18.3789 19.8835 17.9634C20.1006 17.6791 20.296 17.3948 20.4697 17.0886C20.5782 16.9574 20.5999 16.8043 20.5348 16.6731Z"
      fill="#FF9537"
    />
  </svg>
</template>

<script>
export default {
  name: 'OrangeUserIcon'
};
</script>

<style scoped>

</style>
